var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-content-wrap",class:(_vm.bubbled) ? "bubbled-icon" : null},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"name":_vm.name,"spin":_vm.name === "spinner","scale":_vm.scale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }